// Import the necessary components
import VerofreshRecord from './VerofreshRecord'
class RouteProductRecordedTemperatureRecord extends VerofreshRecord {
}

export default RouteProductRecordedTemperatureRecord
